import { useState, useEffect } from 'react';

const useIonicScrollTracker = (delay = 1000) => {
  const [scrollTop, setScrollTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      const element = document.querySelector('ion-content');

      const shadowRoot = element ? element.shadowRoot : null;

      if (shadowRoot) {
        const scrollElement = shadowRoot.children[1];

        if (!scrollElement) return;
        {
          setClientHeight(scrollElement.scrollHeight);
        }

        const handleScroll = () => {
          setScrollTop(scrollElement.scrollTop);
        };

        scrollElement.addEventListener('scroll', handleScroll);

        return () => {
          scrollElement.removeEventListener('scroll', handleScroll);
        };
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return { scrollTop, clientHeight };
};

export default useIonicScrollTracker;
